export default function (data) {
  if ((this.imageData || data) && this.imageData !== data) {
    let image = new Image()
    image.addEventListener('load', () => {
      let width = image.naturalWidth
      let height = image.naturalHeight

      this.internalImageData = (width && height) ? data : null
      this.internalImageWidth = width
      this.internalImageHeight = height
      this.$imageWidth =
        this.imageWidth ||
        (this.imageHeight * this.internalImageWidth) / this.internalImageHeight

      this.flippedHorizontally = false
      this.flippedVertically = false
      this.rotated = false
      this.scaling = 0
      this.dirtyOriginLeft = 0
      this.dirtyOriginTop = 0
      this._scaling = 0
      this._dirtyOriginLeft = 0
      this._dirtyOriginTop = 0
    })
    image.src = data
  }
}
